import React from "react";
import { Link } from 'react-router-dom'
import BlockColorCode from "../../Devices/DevServices/BlockColorCode"

const SPr_01a_Devs = (props) => {
    const {data, onlineContent} = props
    //console.log(data)
    if (!data) return null
    return (
      <div className="container mt-1">
      <table className="table table-striped">
          <thead>
              <tr>
                  <th>ID</th>
  
                  <th>Desk Name</th>
                  <th>Info</th>
  
              </tr>
          </thead>
          <tbody>
            {
              data.map((v,i) => {
                return (
                  <tr key={`desk_${i}`}>
                  <td><Link to={`/selected_desk_mobile/${v.id}`}>{v.id}</Link></td>
                  <td><Link to={`/selected_desk_mobile/${v.id}`}><span className="text-secondary">{v.desk_name}</span></Link></td>
                  <td className="text-left">
                    <div className="d-inline-block">
                      <BlockColorCode
                        project_color_code={v.desk_color_code}
                        dataName="desk_color_code"
                      />
                    </div>
                  </td>
      
                </tr>
                )
              })
            }
  
          </tbody>
      </table>
  </div>
    )
  }

  export default SPr_01a_Devs